import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../services/api";
import { useTranslation } from "../i18n";
import "./Login.css";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState(token ? "loading" : "no-token");
  const { t } = useTranslation();

  useEffect(() => {
    if (!token) return;
    api.verifyEmail(token)
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="login-page">
      <div className="login-bg">
        <div className="login-gradient" />
      </div>

      <div className="login-container" style={{ justifyContent: "center" }}>
        <div className="login-card" style={{ textAlign: "center" }}>
          <div className="login-header">
            <Link to="/" className="login-brand">
              <img src="/logos/mark-black-background.jpg" alt="ViewsDay" className="login-logo" />
            </Link>

            {status === "loading" && (
              <>
                <div style={{ margin: "24px auto" }}>
                  <span className="btn-spinner" />
                </div>
                <p className="login-subtitle">{t("auth.verifying")}</p>
              </>
            )}

            {status === "no-token" && (
              <>
                <h1 className="login-title" style={{ color: "var(--danger)" }}>
                  {t("auth.invalidVerifyLink")}
                </h1>
                <div style={{ marginTop: 24 }}>
                  <Link to="/login" className="btn-primary" style={{ textDecoration: "none" }}>
                    {t("auth.goToLogin")}
                  </Link>
                </div>
              </>
            )}

            {status === "success" && (
              <>
                <div style={{ fontSize: 48, marginBottom: 16 }}>&#10003;</div>
                <h1 className="login-title" style={{ color: "var(--success)" }}>
                  {t("auth.emailVerified")}
                </h1>
                <div style={{ marginTop: 24 }}>
                  <Link to="/login" className="btn-primary" style={{ textDecoration: "none" }}>
                    {t("auth.goToLogin")}
                  </Link>
                </div>
              </>
            )}

            {status === "error" && (
              <>
                <h1 className="login-title" style={{ color: "var(--danger)" }}>
                  {t("auth.verifyExpired")}
                </h1>
                <div style={{ marginTop: 24 }}>
                  <Link to="/login" className="btn-primary" style={{ textDecoration: "none" }}>
                    {t("auth.goToLogin")}
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
